// extracted by mini-css-extract-plugin
export default {"search":"ProductsSearch_search__Q09+I","search_icon":"ProductsSearch_search_icon__qbeqz","emptySearch":"ProductsSearch_emptySearch__x4ys2"};